import { useEffect, useState } from 'react';
import _ from 'lodash';
import { getAdditionalTypesFlatten } from './InputsSetting/AdditionalTypesSelector/additional-types.utils';

const useFormInputsSetting = inputsSetting => {
  const [excludedTypes, setExcludedTypes] = useState(
    _.get(inputsSetting, 'value.excluded_types', [])
  );
  const [additionalTypes, setAdditionalTypes] = useState(
    _.get(inputsSetting, 'value.additional_types', [])
  );
  const [isAdditionalTypesAdded, setIsAdditionalTypesAdded] = useState(false);

  const checkIfAdditionalTypesAdded = () => {
    setIsAdditionalTypesAdded(
      !!_.size(
        _.differenceBy(
          getAdditionalTypesFlatten(additionalTypes),
          getAdditionalTypesFlatten(inputsSetting.additionalTypes),
          'id'
        )
      )
    );
  };

  const toggleExcludedType = type => {
    const updatedExcludedTypes = _.xor(excludedTypes, [type]);
    setExcludedTypes(updatedExcludedTypes);
  };

  useEffect(() => {
    checkIfAdditionalTypesAdded();
  }, [additionalTypes]);

  return {
    excludedTypes,
    toggleExcludedType,
    additionalTypes,
    isAdditionalTypesAdded,
    setAdditionalTypes
  };
};

export default useFormInputsSetting;
